import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=1f6904b0&"
import script from "./DynamicContent.vue?vue&type=script&lang=ts&"
export * from "./DynamicContent.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicContent.vue?vue&type=style&index=0&id=1f6904b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports